import {
  cloneDeep,
  every,
  filter,
  find,
  findIndex,
  includes,
  isEmpty,
} from 'lodash';

import { ChildStep, GUIDE_STEPS, GUIDE_URL } from './constants';

export const getGuideStepByKey = (key: string): ChildStep | undefined =>
  find(GUIDE_STEPS, step => step.key === key) as ChildStep | undefined;

export const getGuideStepByPath = path =>
  find(GUIDE_STEPS, step => step.path.replace(`${GUIDE_URL}/`, '') === path);

export const getGuideStepSiblingsByParentKey = (parentKey: string) =>
  filter(
    GUIDE_STEPS,
    step => 'parentKey' in step && step.parentKey === parentKey
  );

export const getGuideStepIndexByKey = key =>
  findIndex(GUIDE_STEPS, step => step.key === key);

export const getGuideStepsBySection = (section, steps) =>
  filter(steps, step => step.section === section);

export const isEachStepSiblingComplete = (step, stepsSeen) => {
  const { parentKey } = step;
  if (!parentKey) {
    return false;
  }
  const stepSiblings = getGuideStepSiblingsByParentKey(parentKey);
  return every(stepSiblings, sibling => includes(stepsSeen, sibling.key));
};

export const isSectionComplete = (section, steps, stepsSeen) => {
  const sectionSteps = getGuideStepsBySection(section, steps);
  return every(sectionSteps, step => includes(stepsSeen, step.key));
};

export const updateGuideProgress = (step, stepsSeen) => {
  const { key, parentKey } = step;
  const updatedStepsSeen = isEmpty(stepsSeen) ? [] : cloneDeep(stepsSeen);
  if (!includes(stepsSeen, key)) {
    updatedStepsSeen.push(key);
  }

  const isParentTaskComplete = isEachStepSiblingComplete(
    step,
    updatedStepsSeen
  );
  if (isParentTaskComplete && !includes(stepsSeen, parentKey)) {
    updatedStepsSeen.push(parentKey);
  }

  return {
    lastStepSeen: key,
    stepsSeen: updatedStepsSeen,
  };
};

export const scrollToTopOfStepContent = () => {
  // Step content has CSS overflow-y: scroll. This makes it so we can scroll to
  // the top of the content.
  const stepContentElem = document.querySelector('.step-content__main');
  if (stepContentElem) {
    // #27388 Edge doesn't support `.scrollTo()`
    if (!('scrollBehavior' in document.documentElement.style)) {
      stepContentElem.scrollLeft = 0;
      stepContentElem.scrollTop = 0;
      return;
    }

    stepContentElem.scrollTo(0, 0);
  }
};
